module.exports = {
  productsDataDir: 'products', // The name of directory that contains your products.
  siteTitle: 'SolarPower – Calculadora Energética', // Site title.
  siteTitleAlt: 'Solar-Power', // Alternative site title for SEO.
  siteLogo: '/logos/logo-sp-1024.png', // Logo used for SEO and manifest.
  siteUrl: 'https://consumo.solar-power.cl', // Domain of your website without pathPrefix.
  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription:
    'Únete a la revolución ecológica! Revisa nuestros equipos solares de iluminación autónoma. Todo en Iluminación Solar, focos solares, iluminación sustentable y ecológica, solar power.', // Website description used for RSS feeds/meta description tag.
  siteKeywords:
    'SolarPower, iluminacion solar, foco solar, solar-power, iluminacion autonoma, sustentable, LED solar, panel solar',
  siteRss: '/rss.xml', // Path to the RSS file.
  siteFBAppID: '189722311803009', // FB Application ID for using app insights
  googleAnalyticsID: '', // GA tracking ID.
  disqusShortname: 'solarpowerchile', // Disqus shortname.
  postDefaultCategoryID: 'Energia', // Default category for posts.
  userName: 'Solar-Power', // Username to display in the author segment.
  userTwitter: '', // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: 'Santiago, Chile', // User location to display in the author segment.
  userAvatar:
    'https://instagram.fscl14-1.fna.fbcdn.net/t51.2885-19/s150x150/26068153_158515618118436_2260269867150082048_n.jpg', // User avatar to display in the author segment.
  userDescription:
    'Revisa nuestros equipos solares de iluminación autónoma. Únete a la revolucion ecológica!', // User description to display in the author segment.
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  userLinks: [
    {
      label: 'Instagram',
      url: 'https://www.instagram.com/solarpowerchile',
      iconClassName: 'fa fa-instagram'
    },
    // {
    //   label: 'Twitter',
    //   url: 'https://twitter.com/Vagr9K',
    //   iconClassName: 'fa fa-twitter'
    // },
    {
      label: 'Email',
      url: 'mailto:contacto@solar-power.cl',
      iconClassName: 'fa fa-envelope'
    }
  ],
  copyright: 'Solar-Power, 2018. Una empresa Fadiluk ©', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#0d2c54', // Used for setting manifest and progress theme colors.
  backgroundColor: '#ffffff' // Used for setting manifest background color.
};



// WEBPACK FOOTER //
// ./data/SiteConfig.js